import { useContext } from 'react';
import style from './index.module.less';
import { Drawer } from '@arco-design/web-react';
import { IconRight } from '@arco-design/web-react/icon';
import { SideBarContext } from '@/context/SideBarContext';
import { useAuth } from '@/context/AuthContext';
import { getUserInfo, updateUserBackground, uploadFile } from '@/app/user';
import { useBackground } from '@/context/BackgroundContext';
import { Message } from '@arco-design/web-react';

interface MenuItemProps {
  title: string;
  onClick?: () => void;
}

function MenuItem({ title, onClick }: MenuItemProps) {
  return (
    <div className={style.menuItem} onClick={onClick}>
      <div className={style.menuItemTitle}>{title}</div>
      <div className={style.menuItemIcon}>
        <IconRight />
      </div>
    </div>
  );
}

function SideBarMenu() {
  const { menuVisible, setMenuVisible } = useContext(SideBarContext);
  const authContext = useAuth();
  const { updateBackground } = useBackground();

  const handleClose = () => {
    setMenuVisible(false);
  };

  const handleClickLogout = () => {
    setMenuVisible(false);
    authContext.logout();
  };

  const handlePickImage = () => {
    // 普通浏览器环境，创建文件输入框
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';

    fileInput.onchange = (event) => {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];

      if (file) {
        uploadImage(file);
      }

      // 清理DOM
      document.body.removeChild(fileInput);
    };

    document.body.appendChild(fileInput);
    fileInput.click();
    // 检查是否在HTML5Plus环境
    // @ts-ignore
    // if (window?.plus) {
    //   // HTML5Plus环境，使用原生相册选择
    //   // @ts-ignore
    //   plus.gallery.pick(
    //     // @ts-ignore
    //     (path) => {
    //       // 选择成功回调
    //       // 将文件路径转换为File对象
    //       // @ts-ignore
    //       plus.io.resolveLocalFileSystemURL(path, (entry) => {
    //         // @ts-ignore
    //         entry.file((file) => {
    //           console.log("选择的文件: ", file);
    //           // 上传文件到服务器
    //           uploadImage(file);
    //         });
    //       });
    //     },
    //     // @ts-ignore
    //     (error) => {
    //       console.error('选择图片失败:', error.message);
    //     },
    //     {
    //       filter: 'image', // 只显示图片文件
    //       multiple: false, // 不允许多选
    //       system: false, // 不显示系统相册
    //     }
    //   );
    // } else {
    //   // 普通浏览器环境，创建文件输入框
    //   const fileInput = document.createElement('input');
    //   fileInput.type = 'file';
    //   fileInput.accept = 'image/*';
    //   fileInput.style.display = 'none';
    //
    //   fileInput.onchange = (event) => {
    //     const target = event.target as HTMLInputElement;
    //     const file = target.files?.[0];
    //
    //     if (file) {
    //       uploadImage(file);
    //     }
    //
    //     // 清理DOM
    //     document.body.removeChild(fileInput);
    //   };
    //
    //   document.body.appendChild(fileInput);
    //   fileInput.click();
    // }
  };

  // 上传图片函数
  const uploadImage = async (file: File) => {
    console.log("上传的文件: ", JSON.stringify(file));
    try {
      const result = await uploadFile(file);
      console.log('上传成功:', result);
      const b = await updateUserBackground(result.url);
      console.log("更新背景结果: ", b);

      // 更新背景图片状态，触发视图更新
      updateBackground(result.fullurl || result.url);

      // 刷新用户信息
      await getUserInfo();
      setMenuVisible(false);
      // 提示用户更新成功
      Message.success('背景修改成功');
    } catch (error) {
      console.error('上传失败:', error);
      Message.error('背景修改失败');
    }
  };

  return (
    <Drawer visible={menuVisible} footer={null} title={null} placement="right" closable={false} onCancel={handleClose} className={style.sideBarMenu}>
      <div className={style.sideBarMenuWrapper}>
        <div className={style.menuSectionTitle}>系统设置</div>
        <div className={style.menuSection}>
          <MenuItem title="背景修改" onClick={() => handlePickImage()} />
          <MenuItem title="切换夜间模式" onClick={() => {}} />
          <MenuItem title="消息设置" onClick={() => {}} />
        </div>

        <div className={style.menuSectionTitle}>其他设置</div>
        <div className={style.menuSection}>
          <MenuItem title="清除缓存" onClick={() => {}} />
          <MenuItem title="退出登录" onClick={() => handleClickLogout()} />
        </div>
      </div>
    </Drawer>
  );
}

export default SideBarMenu;
